<template>
    <div
        class="md-house layout8 mg-bg"
        :style="{ ...spaceStyle, ...colorStyle, background: bgColor }"
        v-if="result && result.listings && result.listings.length > 0"
    >
        <div class="house-container" :class="{ pc: !isMobile }">
            <div class="title-wrap f-col">
                <site-title
                    :title="title"
                    class="house-title"
                />
                <site-sub-title
                    class="desc"
                    :size="16"
                    :mbSize="16"
                    :title="desc"
                />
            </div>
            <div 
                class="layout8-house-swiper" 
                v-if="result.listings && result.listings.length > 0"
            >
                <Swiper
                    v-bind="swiperOption"
                    @observerUpdate="contentUpdated"
                >
                    <Slide v-for="item in result.listings" :key="item.id">
                        <house :house="item" />
                    </Slide>
                </Swiper>
                <div class="button-swiper" v-if="!isMobileSize">
                    <div class="house-prev iconfont icon-arrow-up"></div>
                    <div class="house-next iconfont icon-arrow-up"></div>
                </div>
            </div>
            <div class="btn-wrap" v-if="result?.listings?.length > 0 && moreShow && moreText">
                <site-button
                    v-if="moreShow && moreText"
                    :html="moreText"
                    class="view-all-listings-btn"
                    :href="moreLink"
                    :aria-label="moreLinkPurpose"
                    rel="noopener noreferrer"
                />
            </div>
        </div>
    </div>
</template>
<script>
import Core from '../index.js';
import list from '../list.js';
import house from './house.vue';
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
export default {
    mixins: [Core, list],
    components: {
        house,
        Swiper,
        Slide: SwiperSlide
    },
    data: function() {
        return {
        };
    },
    computed: {
        coverflowScale() {
            let screenWidth = window.innerWidth;
            let scale = (50 - (100 / screenWidth) * 100) / 50;
            return scale;
        },
        swiperOption({ isMobile, topSwiperOption, result }) {
            let defaultSwiperOption = {
                slidesPerView: 'auto',
                loop: result.listings?.length <= 3 ? false : true,
                navigation: {
                    closest: '.md-house',
                    nextEl: '.house-next',
                    prevEl: '.house-prev',
                    disabledClass: 'house-swiper-disabled'
                },
                direction: 'horizontal',
                centeredSlides: true,
                centeredSlidesBounds: false,
                spaceBetween: 0,
                effect: 'coverflow',
                initialSlide: 0,
                observer: true,
                coverflowEffect: {
                    rotate: 0,
                    depth: 0,
                    scale: isMobile ? 1 : this.coverflowScale,
                    slideShadows: false
                }
            };
            let { autoplay, playInterval, speed } = this;
            if (autoplay) {
                defaultSwiperOption.autoplay = {
                    delay: playInterval ? playInterval * 1000 : 3000,
                    disableOnInteraction: false
                };
            } else {
                defaultSwiperOption.autoplay = false;
            }
            if (speed) {
                defaultSwiperOption.speed = speed;
            }
            if (topSwiperOption) {
                Object.assign(defaultSwiperOption, topSwiperOption());
            }
            if (isMobile) {
                return fixSwiperOptions({
                    ...defaultSwiperOption,
                    spaceBetween: 10,
                    effect: 'slide',
                    centeredSlides: false,
                    autoHeight: true
                });
            } else {
                return fixSwiperOptions(defaultSwiperOption);
            }
        }
    },
    methods: {
        contentUpdated(swiper) {
            if (this.resultUpdated) {
                swiper.slideNext();
                this.resultUpdated = false;
            }
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.md-house.layout8 {
    background: #fff;

    .house-container {
        position: relative;

        .title-wrap {
            margin-bottom: 40px;
            .site-title {
                text-align: left;
            }
            .desc {
                margin-top: 12px;
                text-align: left;
            }
            @include media-800 {
                margin-bottom: 20px;
            }
        }
    }
    .layout8-house-swiper{
        position: relative;
    }
    .button-swiper {
        position: absolute;
        z-index: var(--level-low);
        width: calc(50vw + 150px);
        height: 50px;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        display: flex;
        justify-content: space-between;

        .house-next,
        .house-prev {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: var(--g-btn-background);
            color: var(--g-btn-color);
            transform: rotate(90deg);
            cursor: pointer;
            &.iconfont {
                font-size: 24px;
            }
            &:hover::after {
                content: '';
                background: rgba(25, 25, 25, 0.1);
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
            &.house-swiper-disabled,
            &.swiper-button-lock {
                cursor: not-allowed;
                opacity: 0.3;
                &:hover::after {
                    content: '';
                    background: transparent;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                }
            }
            &.house-prev {
                transform: rotate(-90deg);
            }
        }
    }

    .swiper {
        margin-left: auto;
        margin-right: auto;
        position: relative;
        .swiper-wrapper {
            position: relative;
            width: 100%;
            z-index: 1;
            transition-property: transform;
            display: flex;
            align-items: center;

            .swiper-slide {
                transition-duration: 0ms;
                width: 50vw;
                z-index: 0;

                &.swiper-slide-active {
                    z-index: 1;
                    .house-slider-item {
                        .house-info {
                            display: flex;
                        }
                    }
                }

                .house-slider-item {
                    width: 100%;
                    height: 475px;
                }

                @media (min-width: 1920px) {
                    .house-slider-item {
                        height: 634px;
                    }
                }

                @media (max-width: 1000px) {
                    .house-slider-item {
                        height: 330px;
                    }
                }
            }
        }
    }
    
    .btn-wrap {
        width: 200px;
        margin: 40px auto 0 auto;
        .view-all-listings-btn {
            box-sizing: border-box;
            display: block;
            width: 100%;
            height: 50px;
            padding: 15px;
            text-align: center;
            line-height: 20px;
            font-family: var(--font-normal);
            font-size: 16px;
        }
    }
    

    @include media-800 {
        .layout8-house-swiper {
            padding-left: 15px;
        }
        .swiper .swiper-wrapper {
            align-items: flex-start;
            .swiper-slide {
                width: 330px;
                height: auto;
                z-index: 0;

                .house-slider-item {
                    width: 100%;
                    height: 100%;

                    .house-preview {
                        .house-info {
                            overflow: hidden;
                        }
                    }
                }
            }
        }
        

        .btn-wrap {
            width: 200px;
            margin: 20px auto 0 auto;
        }
    }
}
</style>
